export default __webpack_public_path__ + "static/media/upload_member_data.3b8a75b2.svg";